/* =========================================================
   Immortalising Moments — storefront behaviour
   ========================================================= */

(function () {
  'use strict';

  var T = window.theme || {};
  var routes = T.routes || {};

  /* ---------- helpers ---------- */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function announce(message) {
    var region = $('#LiveRegion');
    if (region) { region.textContent = ''; setTimeout(function () { region.textContent = message; }, 60); }
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = T.moneyFormat || '${{amount}}';
    var parts = amount.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var value = withCommas + '.' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function trapFocus(container) {
    var focusable = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return function () {};
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function handler(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', handler);
    first.focus({ preventScroll: true });
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- overlay + panels ---------- */

  var Panels = {
    active: null,
    release: null,
    lastFocus: null,

    open: function (el) {
      if (!el) return;
      if (this.active && this.active !== el) this.close();
      this.lastFocus = document.activeElement;
      el.classList.add('is-open');
      el.removeAttribute('inert');
      el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      var overlay = $('#Overlay');
      if (overlay) overlay.classList.add('is-visible');
      this.active = el;
      this.release = trapFocus(el);
    },

    close: function () {
      if (!this.active) return;
      this.active.classList.remove('is-open');
      this.active.setAttribute('aria-hidden', 'true');
      if (this.release) this.release();
      var overlay = $('#Overlay');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('no-scroll');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      this.active = null;
    }
  };

  window.themePanels = Panels;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) {
      e.preventDefault();
      Panels.open($('#' + opener.getAttribute('data-panel-open')));
      var target = $('#' + opener.getAttribute('data-panel-open'));
      if (target && target.id === 'SearchModal') {
        var input = $('input[type="search"]', target);
        if (input) setTimeout(function () { input.focus(); }, 120);
      }
      return;
    }
    if (e.target.closest('[data-panel-close]') || e.target.id === 'Overlay') {
      Panels.close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Panels.close();
  });

  /* ---------- dropdown navigation ---------- */

  $$('.nav__item--has-panel').forEach(function (item) {
    var toggle = $('.nav__link', item);
    var closeTimer;

    function open() { clearTimeout(closeTimer); item.classList.add('is-open'); if (toggle) toggle.setAttribute('aria-expanded', 'true'); }
    function close() { item.classList.remove('is-open'); if (toggle) toggle.setAttribute('aria-expanded', 'false'); }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 120); });
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) close();
    });
    if (toggle && toggle.tagName === 'BUTTON') {
      toggle.addEventListener('click', function () {
        item.classList.contains('is-open') ? close() : open();
      });
    }
  });

  /* ---------- mobile menu accordions ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.menu-drawer__link[data-submenu]');
    if (!btn) return;
    var item = btn.closest('.menu-drawer__item');
    var open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- accordions ---------- */

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;
    var panel = trigger.nextElementSibling;
    var open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.classList.toggle('is-open', !open);
  });

  /* ---------- quantity inputs ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity button');
    if (!btn) return;
    e.preventDefault();
    var input = $('input', btn.parentElement);
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart ---------- */

  var Cart = {
    updateCount: function (count) {
      $$('.js-cart-count').forEach(function (el) {
        el.textContent = count;
        if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
      });
    },

    refreshDrawer: function () {
      return fetch(routes.root + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var wrapper = $('#shopify-section-cart-drawer');
          if (!wrapper) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('#shopify-section-cart-drawer', doc) || doc.body.firstElementChild;
          if (fresh) wrapper.innerHTML = fresh.innerHTML;
          Cart.bindShippingBar();
        });
    },

    refreshPage: function () {
      return fetch(window.location.pathname + '?section_id=main-cart')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var wrapper = $('#shopify-section-main-cart');
          if (!wrapper) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('#shopify-section-main-cart', doc) || doc.body.firstElementChild;
          if (fresh) wrapper.innerHTML = fresh.innerHTML;
        });
    },

    add: function (formData, button) {
      if (button) {
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');
        button.dataset.label = button.textContent;
        button.innerHTML = '<span>' + (T.strings.adding || 'Adding') + '</span>';
      }

      return fetch(routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            Cart.showError(button, data.description || data.message);
            return;
          }
          return fetch(routes.cart + '.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              Cart.updateCount(cart.item_count);
              announce(T.strings.added || 'Added');
              if (button) {
                button.innerHTML = '<span>' + (T.strings.added || 'Added') + '</span>';
                setTimeout(function () { Cart.resetButton(button); }, 1600);
              }
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
              if (T.cartType === 'drawer') {
                return Cart.refreshDrawer().then(function () { Panels.open($('#CartDrawer')); });
              }
              window.location.href = routes.cart;
            });
        })
        .catch(function () { Cart.showError(button, 'Could not add to cart. Try again.'); });
    },

    resetButton: function (button) {
      if (!button) return;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-disabled');
      button.innerHTML = '<span>' + (button.dataset.label || T.strings.addToCart) + '</span>';
    },

    showError: function (button, message) {
      Cart.resetButton(button);
      if (!message) return;
      var form = button ? button.closest('form') : null;
      var target = form ? $('.form-status', form) : null;
      if (target) {
        target.textContent = message;
        target.hidden = false;
        target.classList.add('form-status--error');
      } else {
        announce(message);
      }
    },

    change: function (line, quantity) {
      return fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          Cart.updateCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if ($('#shopify-section-main-cart')) return Cart.refreshPage();
          return Cart.refreshDrawer();
        });
    },

    bindShippingBar: function () {
      var bar = $('.shipping-bar');
      if (!bar) return;
      var fill = $('.shipping-bar__fill', bar);
      var total = parseInt(bar.getAttribute('data-total') || '0', 10);
      var threshold = T.freeShipping ? T.freeShipping.threshold : 0;
      if (fill && threshold > 0) fill.style.width = Math.min(100, (total / threshold) * 100) + '%';
    }
  };

  window.themeCart = Cart;

  // add to cart forms
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form || form.getAttribute('data-ajax-cart') === 'false') return;

    var terms = $('#CartTerms');
    if (terms && !terms.checked && form.hasAttribute('data-checkout-form')) {
      e.preventDefault();
      announce(T.strings.termsError);
      return;
    }

    e.preventDefault();
    var button = $('[type="submit"]', form);
    var status = $('.form-status', form);
    if (status) status.hidden = true;
    var data = new FormData(form);
    Cart.add(data, button);
  });

  // quantity + remove inside cart
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-quantity]');
    if (!input) return;
    Cart.change(input.getAttribute('data-line'), input.value);
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    Cart.change(remove.getAttribute('data-line'), 0);
  });

  // order note
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  // terms gate on checkout buttons
  document.addEventListener('click', function (e) {
    var checkout = e.target.closest('[data-checkout]');
    if (!checkout) return;
    var terms = $('#CartTerms');
    if (terms && !terms.checked) {
      e.preventDefault();
      var msg = $('#CartTermsError');
      if (msg) msg.hidden = false;
      announce(T.strings.termsError);
    }
  });

  Cart.bindShippingBar();
  document.addEventListener('cart:updated', function () { setTimeout(Cart.bindShippingBar, 100); });

  /* ---------- variant picker ---------- */

  function ProductForm(root) {
    var dataEl = $('[data-variant-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = $('[data-variant-id]', root);
    var priceWrap = $('[data-price-wrap]', root);
    var submit = $('[type="submit"]', root);
    var skuEl = $('[data-sku]', root);
    var inventoryEl = $('[data-inventory]', root);
    var updateUrl = root.getAttribute('data-update-url') !== 'false';

    function selectedOptions() {
      return $$('[data-option-index]', root)
        .filter(function (el) { return el.type !== 'radio' || el.checked; })
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (el) { return el.value; });
    }

    function matchVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      });
    }

    function updateAvailability(options) {
      $$('[data-option-index]', root).forEach(function (input) {
        if (input.type !== 'radio') return;
        var index = parseInt(input.getAttribute('data-option-index'), 10);
        var test = options.slice();
        test[index] = input.value;
        var candidates = variants.filter(function (v) {
          return v.options.every(function (opt, i) { return i === index ? opt === input.value : opt === test[i]; });
        });
        var available = candidates.some(function (v) { return v.available; });
        var label = root.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('is-unavailable', !available);
      });
    }

    function render() {
      var options = selectedOptions();
      var variant = matchVariant(options);
      updateAvailability(options);

      $$('[data-selected-value]', root).forEach(function (el) {
        var index = parseInt(el.getAttribute('data-selected-value'), 10);
        if (options[index]) el.textContent = options[index];
      });

      if (!variant) {
        if (submit) {
          submit.setAttribute('disabled', 'disabled');
          submit.innerHTML = '<span>' + T.strings.unavailable + '</span>';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceWrap) {
        var html = '<span class="' + (variant.compare_at_price > variant.price ? 'price__sale' : '') + '">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price > variant.price) {
          html += ' <span class="price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
        }
        priceWrap.innerHTML = html;
      }

      if (skuEl) skuEl.textContent = variant.sku || '—';

      if (inventoryEl) {
        if (variant.available && variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          inventoryEl.textContent = 'Only ' + variant.inventory_quantity + ' left';
          inventoryEl.hidden = false;
        } else {
          inventoryEl.hidden = true;
        }
      }

      if (submit) {
        if (variant.available) {
          submit.removeAttribute('disabled');
          submit.dataset.label = T.strings.addToCart;
          submit.innerHTML = '<span>' + T.strings.addToCart + '</span>';
        } else {
          submit.setAttribute('disabled', 'disabled');
          submit.innerHTML = '<span>' + T.strings.soldOut + '</span>';
        }
      }

      // move the gallery to the variant's image
      if (variant.featured_media && variant.featured_media.id) {
        var thumb = root.closest('.product') && root.closest('.product').querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }

      if (updateUrl && variant.id && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: variant } }));
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) render();
    });

    render();
  }

  $$('[data-product-form]').forEach(ProductForm);

  /* ---------- product gallery ---------- */

  $$('[data-gallery]').forEach(function (gallery) {
    var main = $('[data-gallery-main]', gallery);
    if (!main) return;
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-media-id]');
      if (!thumb) return;
      e.preventDefault();
      var src = thumb.getAttribute('data-media-src');
      var alt = thumb.getAttribute('data-media-alt') || '';
      var img = $('img', main);
      if (img && src) {
        img.src = src;
        img.srcset = thumb.getAttribute('data-media-srcset') || '';
        img.alt = alt;
      }
      $$('[data-media-id]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---------- quick add ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var data = new FormData();
    data.append('id', btn.getAttribute('data-quick-add'));
    data.append('quantity', 1);
    Cart.add(data, btn);
  });

  /* ---------- predictive search ---------- */

  var searchInput = $('[data-predictive-input]');
  if (searchInput && T.strings) {
    var resultsEl = $('[data-predictive-results]');
    var searchTimer;

    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) { if (resultsEl) resultsEl.innerHTML = ''; return; }
      searchTimer = setTimeout(function () {
        fetch(routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article,page&resources[limit]=5&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = $('#shopify-section-predictive-search', doc);
            if (resultsEl) resultsEl.innerHTML = inner ? inner.innerHTML : '';
          });
      }, 250);
    });
  }

  /* ---------- facets ---------- */

  $$('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form)).toString();
      var url = window.location.pathname + '?' + params;
      fetch(url + '&section_id=' + form.getAttribute('data-section-id'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-collection-results]');
          var current = document.querySelector('[data-collection-results]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var freshFacets = doc.querySelector('[data-facet-form]');
          if (freshFacets && form.parentElement) form.innerHTML = freshFacets.innerHTML;
          window.history.pushState({}, '', url);
          initReveal();
        });
    });
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.facet__toggle');
    if (toggle) {
      var facet = toggle.closest('.facet');
      var open = facet.classList.contains('is-open');
      $$('.facet').forEach(function (f) { f.classList.remove('is-open'); });
      facet.classList.toggle('is-open', !open);
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }
    if (!e.target.closest('.facet')) $$('.facet').forEach(function (f) { f.classList.remove('is-open'); });
  });

  var sortSelect = $('[data-sort-by]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- announcement rotation ---------- */

  var announcement = $('[data-announcement]');
  if (announcement) {
    var slides = $$('.announcement__slide', announcement);
    if (slides.length > 1) {
      var index = 0;
      setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, parseInt(announcement.getAttribute('data-interval') || '5000', 10));
    }
  }

  /* ---------- scroll reveal ---------- */

  function initReveal() {
    if (!T.animations) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = $$('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.getAttribute('data-reveal-delay') || '0', 10);
        setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { observer.observe(el); });
  }

  initReveal();

  /* ---------- personalisation gate ---------- */
  /* Print-on-demand apps attach the customer's artwork to the product form as
     line item properties. Until one of those carries a value, there is nothing
     to print, so the add to cart button stays out of the way. */

  function hasArtwork(form) {
    var fields = $$('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]', form);
    return fields.some(function (field) {
      if (field.type === 'checkbox' || field.type === 'radio') return field.checked;
      return field.value && field.value.trim() !== '';
    });
  }

  function PersonalisationGate(form) {
    var mode = form.getAttribute('data-gate');
    if (mode !== 'unlock') return;

    // If no personalisation app block has been added to the product template
    // there is nothing to unlock the button, so fail open rather than leaving
    // the product unbuyable.
    var designer =
      $('[data-app-block]') ||
      $('.shopify-app-block') ||
      $('[id*="gelato" i], [class*="gelato" i], [data-gelato]') ||
      $$('button, a').filter(function (el) {
        return /personali[sz]/i.test(el.textContent || '');
      })[0];

    if (!designer) {
      form.setAttribute('data-gate', 'unlocked');
      return;
    }

    var checks = 0;
    var timer;

    function unlock() {
      form.setAttribute('data-gate', 'unlocked');
      clearInterval(timer);
      if (observer) observer.disconnect();
      announce(T.strings.addToCart);
    }

    function check() {
      checks += 1;
      if (hasArtwork(form)) unlock();
      else if (checks > 150) clearInterval(timer);
    }

    var observer = null;
    if ('MutationObserver' in window) {
      observer = new MutationObserver(check);
      observer.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
    }

    form.addEventListener('change', check);
    form.addEventListener('input', check);

    // Some designers write values straight into existing inputs, which fires
    // nothing observable, so poll gently for a couple of minutes as well.
    timer = setInterval(check, 800);

    check();
  }

  function initGates(scope) {
    $$('form[data-gate]', scope).forEach(PersonalisationGate);
  }

  initGates(document);

  // Apps that prefer to announce themselves can just fire this event.
  document.addEventListener('personalisation:complete', function (e) {
    var form = (e.detail && e.detail.form) || $('form[data-gate="unlock"]');
    if (form) form.setAttribute('data-gate', 'unlocked');
  });

  /* ---------- product recommendations ---------- */

  var recoHolder = $('[data-recommendations-url]');
  if (recoHolder) {
    fetch(recoHolder.getAttribute('data-recommendations-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.page-width');
        if (fresh && fresh.innerHTML.trim()) {
          recoHolder.innerHTML = fresh.innerHTML;
          initReveal();
        }
      })
      .catch(function () {});
  }

  /* ---------- share ---------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-share') || window.location.href;
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function () {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { announce(T.strings.linkCopied); });
    }
  });

  /* ---------- localisation forms ---------- */

  $$('[data-localization-form] select').forEach(function (select) {
    select.addEventListener('change', function () {
      select.closest('form').submit();
    });
  });

  /* ---------- theme editor hooks ---------- */

  document.addEventListener('shopify:section:load', function (event) {
    $$('[data-product-form]', event.target).forEach(ProductForm);
    initGates(event.target);
    initReveal();
    Cart.bindShippingBar();
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (event.target.querySelector('.cart-drawer')) Panels.open($('#CartDrawer'));
  });
})();
